.icon {
  margin-right: var(--dds-spacing-x0-25);
}
